import * as _auth from './auth';
import * as _gider from './gider';
import * as _sirket from './sirket';
import * as _musteri from './musteri';
import * as _musteriKontrol from './musteriKontrol.js';
import * as _musteriMakina from './musteriMakina.js';
import * as _koku from './koku.js';
import * as _makina from './makina.js';
import * as _makinaFoto from './makinaFoto.js';
import * as _tahsilat from './tahsilat.js';

export const Auth = _auth;
export const Gider = _gider;
export const Sirket = _sirket;
export const Musteri = _musteri;
export const MusteriKontrol = _musteriKontrol;
export const MusteriMakina = _musteriMakina;
export const Koku = _koku;
export const Makina = _makina;
export const MakinaFoto = _makinaFoto;
export const Tahsilat = _tahsilat;


export default {
    Auth,
    MusteriKontrol,
    MusteriMakina,
    Gider,
    Sirket,
    Musteri,
    Koku,
    Makina,
    MakinaFoto,
    Tahsilat,
};
